import "./_internal/CasStackRow.scss";

import { Stack, StackProps } from '@mui/material';
import { useResponsive } from 'src/hooks/use-responsive';

type CasStackRowProps = {
  children: React.ReactNode;
  justifyContent?: StackProps['justifyContent'];
  alignItems?: StackProps['alignItems'];
  flexGrow?: StackProps['flexGrow'];
  gapSize?: 'none' | 'small' | 'large';
  indent?: number;
  className?:StackProps['className'];
  backgroundColor?: string;
};

export function CasStackRow({
  children,
  gapSize = 'small',
  indent = 0,
  backgroundColor,
  alignItems,
  className='',
  ...rest
}: CasStackRowProps) {
  const gapMap = {
    none: 0,
    small: 1,
    large: 2,
  };

  const marginLeft = 2 * indent;
  const smDown = useResponsive('down', 'sm');

  if (alignItems==='center') {
    className += ' control-no-margin';
  }

  return (
    <Stack
      flexDirection="row"
      gap={gapMap[gapSize]}
      rowGap="8px"
      ml={marginLeft}
      flexWrap={smDown ? 'wrap' : 'nowrap'}
      sx={backgroundColor ? { backgroundColor } : undefined}
      alignItems={alignItems}
      className={className}
      {...rest}
    >
      {children}
    </Stack>
  );
}
